/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconSideswipe: {
  name: 'sideswipe';
  data: string;
} = {
  name: 'sideswipe',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M622.235 585.006c0-136.689-1.848-142.23-1.848-142.23 303.939-86.884-315.829-114.695-375.512-106.763l-.224 51.643L68.292 286.627l175.819-97.018 2.072 50.244c451.249-8.484 551.555 124.775 376.052 345.153z" transform="translate(-28.784 -32.647) scale(.87033)"/></svg>`,
};
